import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { defer, Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { timeoutError } from '../../models/timeout-error';
import { TimeoutLimit } from '../../models/timeout-limit';
import { Store } from '@ngrx/store';
import { RootState } from '../../state/state';
import { addMultipleJetStreamMessagesNoDuplicate } from '../message-service/state/message.actions';
import { MessageKey } from '../../models/message/message-key';
import { SliceBySliceReshopRequest } from '../../dtos/request/reshop-request/slice-by-slice/slice-by-slice-reshop-request';
import { SliceBySliceReshopResponse } from '../../dtos/response/reshop-response/slice-by-slice/slice-by-slice-reshop-response';
import { SliceBySliceReshopResponseWrapper } from '../../dtos/response/reshop-response/slice-by-slice/slice-by-slice-reshop-response-wrapper';

export interface FlightReshopServiceAPI {
  getSliceBySliceResults(request: SliceBySliceReshopRequest): Observable<SliceBySliceReshopResponseWrapper>;
}

@Injectable()
export class FlightReshopService implements FlightReshopServiceAPI {
  private readonly http = inject(HttpClient);
  private readonly store = inject<Store<RootState>>(Store);

  getSliceBySliceResults(request: SliceBySliceReshopRequest): Observable<SliceBySliceReshopResponseWrapper> {
    const options = {
      headers: new HttpHeaders({
        background: 'true',
      }),
    };
    return this.http.post<SliceBySliceReshopResponse>('api/flight/shopping/reshop/slice-by-slice', request, options).pipe(
      timeout({
        each: TimeoutLimit.MEDIUM,
        with: () => defer(() => observableThrowError(() => new HttpErrorResponse(timeoutError))),
      }),
      map((response) => {
        return {
          response,
        } as SliceBySliceReshopResponseWrapper;
      }),
      catchError((err: HttpErrorResponse) => {
        const detail = typeof err.error?.detail === 'string' ? err.error.detail : undefined;
        const normalizedDetail = detail?.toLowerCase() ?? '';
        if (normalizedDetail.includes('there were discount validation errors')) {
          this.store.dispatch(addMultipleJetStreamMessagesNoDuplicate([MessageKey.RESHOP_INVALID_SEARCH_DISCOUNT_RULES]));
          return of({ errorStatus: err.status, error: normalizedDetail });
        } else if (timeoutError.statusText === err.statusText) {
          this.store.dispatch(addMultipleJetStreamMessagesNoDuplicate([MessageKey.RESHOP_FLIGHT_SEARCH_TIMEOUT]));
          return of({ errorStatus: err.status, error: 'Timeout' });
        } else {
          // Unsure which errors to catch at this time. Will add more as they are discovered.
          this.store.dispatch(addMultipleJetStreamMessagesNoDuplicate([MessageKey.UNKNOWN_WITH_LINK]));
          return of({ errorStatus: err.status, error: 'Uncaught' });
        }
      })
    );
  }
}
